import React, { useEffect } from "react";
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Contact from "./pages/Contact";
import SingleProduct from "./pages/SingleProduct";
import Cart from "./pages/Cart";
import ErrorPage from "./pages/ErrorPage";
import { GlobalStyle } from "./GlobalStyle";
import { ThemeProvider } from "styled-components";
import Header from "./layout/Header";
import Foot from "./layout/Foot";
import Reset from "./auth/Reset";
import Register from "./auth/Register";
import Password from "./auth/Password";
import Profile from "./user/Profile";
import Username from "./auth/Username";
import Checkout from "./components/checkou";
import ScrollToTop from "./components/ScrollToTop";
//auth middleware
import {AuthorizeUser} from './middleware/auth'
import AddProductForm from "./admin/NewProductForm";
// import AdminProductGrid from "./admin/MasterProductPage";
import EditProductForm from "./admin/EditProductForm";
import { useAuthStore } from "./store/store";
import Policy from "pages/PrivacyPolicy";
import AdminDashboard from "admin/AdminDashboard";
import AdminProduct from "admin/AdminProduct";
import UserDashboard from "user/UserDasboard";
import Orders from "user/Orders";
import CreateCategory from "admin/CreateCategory";
import CreateSubcategory from "admin/CreateSubcategory";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import FAQ from "./pages/FAQ";
import CreateAddress from "./user/CreateAddress";
import UserAddressList from "./user/UserAddressList";
import OrderPrint from "./user/OrderPrint";
import UserList from "admin/UserList";
import UserDetailsPage from "admin/UserDetailsPage";
import AdminOrdersPage from "admin/AdminOrdersPage";
import { Toaster } from "react-hot-toast";
import ForgotPassword from "./auth/ForgotPassword";




const App = () => {
  const loadUserFromStorage = useAuthStore((state) => state.loadUserFromStorage);
  
    useEffect(() => {
      loadUserFromStorage();
    }, [loadUserFromStorage]);

  const theme={
    colors:{
      heading:"rgb(24 24 29)",
      text:"rgba(29 ,29, 29 ,.8)",
      white:"#fff",
      black:"#212529",
      helper:"#8490ff",
      bg:"#F6F8FA",
      font:"#53504E",
      bgl:"#E0F2F0",
      footer_bg:"#0a1435",
      btn:"rgb(98 84 243)",
      border:"#b3b0b0",
      hr:"#b7b3b3",
       shadow:
        "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;",
      shadowSupport: " rgba(0, 0, 0, 0.16) 0px 1px 4px",
   },

    media:{
      mobile:"768px",
      tab:"998px",
    },
  };

  return (

    <ThemeProvider theme={theme}> 
      {/* provides styling to all the components written between this tag */}
     <Toaster position="top-center" />

      <Router>
        <GlobalStyle/>
        <Header/>
        <ScrollToTop />
      <Routes>
        
        <Route path="/" element={<Home/>} />
        <Route path="/about" element={<About/>} />
        <Route path="/products" element={<Products/>} />
        <Route path="/productform" element={<AddProductForm/>} />
        {/*<Route path="/adminproduct" element={<AdminProductGrid/>} /> */}
        <Route path="/policy" element={<Policy/>} />
        <Route path="/contact" element={<Contact/>} />
        <Route path="/singleproduct/:id" element={<SingleProduct/>} />
        <Route path="/editproductform/:id" element={<EditProductForm/>} /> 
        {/* <Route path="/editproductform/:id" element={<EditProductForm/>} />  */}
        <Route path="/cart" element={<Cart/>} />
        
        <Route path="/username" element={<Username/>} />
        {/* <Route path="/username" element={<Username/>} /> */}
        <Route path="/password" element={<Password/>}/>
        <Route path="/checkout" element={<Checkout/>}/>
        <Route path="/register" element={<Register/>} />
        <Route path="/reset" element={<Reset/>} />
        <Route path="/forgot-password" element={<ForgotPassword/>} />
        <Route path="/profile" element={<AuthorizeUser> <Profile/> </AuthorizeUser>}/>
        <Route path="*" element={<ErrorPage/>} />
        <Route path='/userlist' element={<AuthorizeUser> <UserList/> </AuthorizeUser>} /> 
        <Route path='/orders' element={<AuthorizeUser> <Orders/> </AuthorizeUser>} />
        <Route path='/dashboard' element={<AuthorizeUser> <UserDashboard/> </AuthorizeUser>} />
        <Route path='/admindashboard' element={<AuthorizeUser> <AdminDashboard/> </AuthorizeUser>} />
        <Route path='/adminproduct' element={<AuthorizeUser> <AdminProduct/> </AuthorizeUser>} />
        <Route path='/category' element={<AuthorizeUser> <CreateCategory/> </AuthorizeUser>} />
        <Route path='/subcategory' element={<AuthorizeUser> <CreateSubcategory/> </AuthorizeUser>} />
        <Route path='/UserAddressList' element={<AuthorizeUser> <UserAddressList/> </AuthorizeUser>} />
        <Route path="/userdetails/:id" element={<AuthorizeUser><UserDetailsPage /></AuthorizeUser>}/>
        <Route path="/address" element={<CreateAddress/>} />
        <Route path="/orderprint/:id" element={<OrderPrint/>} />
        <Route path="/adminorders" element={<AuthorizeUser><AdminOrdersPage /></AuthorizeUser>}/>
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/FAQ" element={<FAQ/>} />
      
        </Routes>
        <Foot />
      </Router>
      </ThemeProvider>
    
  );
};

export default App;
